// @flow

import { getIn } from 'formik';
import { isEqual } from 'lodash';

import {
  CLUSTER_CONNECTORS_MONTHLY_INPUTS_JSON_CONFIG,
  CLUSTER_RTCE_MONTHLY_INPUTS_JSON_CONFIG,
  CLUSTER_RTCE_STORAGE_TYPE_BACKEND_NAME,
  CLUSTER_TABLEFLOW_STORAGE_TYPE_BACKEND_NAME,
  CONNECTOR_NETWORKING_TYPE_CONNECT_PUBLIC,
  CONNECTOR_SINK_KEYWORD,
  IS_CONNECT_CROSS_CLOUD_REGION_LIVE,
  RTCE_STORAGE_TYPE_CONFLUENT,
  TABLEFLOW_STORAGE_TYPE_CONFLUENT,
} from '../../../constants';
import { doesStringContainSubstringCaseAgnostic } from '../../../common-utils/utils';

import { TABLEFLOW_WIRE_KEY_BY_VERSION } from './tableflow-config';

const isConnectorBeingEdited = (connectorIndex, initialValues, values) => {
  const keyNameInValuesToUseForThisConnector = `${CLUSTER_CONNECTORS_MONTHLY_INPUTS_JSON_CONFIG}.connectors[${connectorIndex}]`;
  const connectorOriginalData = getIn(initialValues, keyNameInValuesToUseForThisConnector);
  const connectorCurrentData = getIn(values, keyNameInValuesToUseForThisConnector);
  return !isEqual(connectorOriginalData, connectorCurrentData);
};

export const isAnyOtherConnectorBeingEdited = (
  totalNumberOfConnectors,
  initialValues,
  values,
  connectorIndex
) => {
  let isAnyConnectorBeingEditedCurrently = false;
  for (let i = 0; i <= totalNumberOfConnectors - 1; i++) {
    if (i === connectorIndex) {
      continue;
    }
    if (isConnectorBeingEdited(i, initialValues, values)) {
      isAnyConnectorBeingEditedCurrently = true;
      break;
    }
  }
  return isAnyConnectorBeingEditedCurrently;
};

export const getIfConfluentStorageIsEnabledFromFormikValues = (formikValues, tableflowVersion) => {
  return (
    getTableflowStorageTypeFromFormikValues(formikValues, tableflowVersion) ===
    TABLEFLOW_STORAGE_TYPE_CONFLUENT
  );
};

export const getTableflowStorageTypeFromFormikValues = (formikValues, tableflowVersion) => {
  const tableflowKey = TABLEFLOW_WIRE_KEY_BY_VERSION[tableflowVersion];
  return formikValues[tableflowKey]?.[CLUSTER_TABLEFLOW_STORAGE_TYPE_BACKEND_NAME];
};

export const getIfRTCEConfluentStorageIsEnabledFromFormikValues = (formikValues) => {
  return getRTCEStorageTypeFromFormikValues(formikValues) === RTCE_STORAGE_TYPE_CONFLUENT;
};

export const getRTCEStorageTypeFromFormikValues = (formikValues) => {
  return formikValues[CLUSTER_RTCE_MONTHLY_INPUTS_JSON_CONFIG]?.[
    CLUSTER_RTCE_STORAGE_TYPE_BACKEND_NAME
  ];
};

export const getIfConnectorIsSinkType = (connectorName) =>
  doesStringContainSubstringCaseAgnostic(connectorName, CONNECTOR_SINK_KEYWORD);

/**
 * Visibility rules for the connector destination dropdowns:
 *  - provider + region show only for sink connectors on connect public networking
 *  - region additionally shows only when the destination stays on the cluster's own provider i.e., same cloud provider
 */
export const getDestinationDropdownsVisibility = ({
  connectorName,
  networkingType,
  destinationProvider,
  clusterProvider,
}) => {
  const showDestinationProvider =
    IS_CONNECT_CROSS_CLOUD_REGION_LIVE &&
    getIfConnectorIsSinkType(connectorName) &&
    networkingType === CONNECTOR_NETWORKING_TYPE_CONNECT_PUBLIC;

  const showDestinationRegion = showDestinationProvider && destinationProvider === clusterProvider;

  return { showDestinationProvider, showDestinationRegion };
};
